import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import * as React from 'react';

import { useStyles } from './styles';
import DialogTitle from '../DialogTitle';

interface ConfirmAddressProps {
  isOpen: boolean;
  setIsOpen: (prev: boolean) => void;
  name: string;
}

const ConfirmUpdateAddress = ({ isOpen, setIsOpen, name }: ConfirmAddressProps) => {
  const theme = useTheme();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onClose={setIsOpen} fullScreen={isMobile} maxWidth='sm'>
      <DialogTitle onClose={handleClose}>
        <Typography>👍 Confirmação de endereço concluída!</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText className={classes.dialogContentContainer}>
          <Typography variant='subtitle1' color='textPrimary' className={classes.bold}>
            {name}
          </Typography>
        </DialogContentText>
        <div className={classes.container}>
          <Typography>Seu endereço foi atualizado com sucesso. 👏</Typography>
          <Typography>
            Agradecemos por nos informar sobre a mudança. Isso garante que seus mimos e reconhecimentos do Programa Elite sejam enviados para o local
            correto. <strong>Em breve, você receberá seus prêmios no novo endereço.</strong>
          </Typography>
          <Typography>Parabéns por suas conquistas e obrigado por fazer parte do 🏆 Programa Elite!</Typography>
        </div>
      </DialogContent>
      <DialogActions className={classes.buttonActionsContainer}>
        <Button onClick={handleClose} color='primary' size='large' variant='contained'>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmUpdateAddress;
